import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.scss';
import store from './redux/store.ts';
import { Provider } from 'react-redux';
import CookiesComponent from './layout/OneTrust.tsx';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme.ts';
import './i18n.ts';
import PostHogWrapper from './layout/PostHogWrapper.tsx';
import { BrowserRouter } from 'react-router';
import initGlobalServiceData from './utils/getGlobalServiceData.ts';

initGlobalServiceData();

ReactDOM.createRoot(document.getElementById('framework-root')!).render(
  <>
    <CookiesComponent />
    <React.StrictMode>
      <PostHogWrapper>
        <ThemeProvider theme={theme}>
          <Provider store={store}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </Provider>
        </ThemeProvider>
      </PostHogWrapper>
    </React.StrictMode>
  </>,
);
